if (!customElements.get('po-birthday-input')) {
  class PoBirthdayInput extends HTMLElement {
      connectedCallback() {
          this.input = this.querySelector('input');
          this.dateInput = document.querySelector(this.dataset.dateInput);
          this.submitButton = document.querySelector(this.dataset.submitButton);
          
          this.clearFieldButton = this.dateInput.closest("po-text-field").querySelector(".js-empty-field");
          this.birthdayErrorElement = document.querySelector('#birthday-error');

          if (!this.input || !this.dateInput) return;

          this.dateInput.addEventListener('change', this.handleBirthdayChange.bind(this));
          this.clearFieldButton.addEventListener('mousedown', this.birthdayInput.bind(this));
          this.dateInput.closest('form')?.addEventListener('submit', (event) => {
              this.birthdayInput();
              if (!this.validateAge()) {
                  event.preventDefault();
                  event.stopPropagation();
                  this.dateInput.focus();
              }
          });

          // Ottieni il paese dell'utente in base all'IP
          this.fetchUserCountry();
      }

      getCountryFromHtmlLang() {
          try {
              const lang = (document.documentElement.getAttribute('lang') || '').trim();
              // theme.liquid sets: lang="{{ request.locale.iso_code | split: '-' | first }}-{{ localization.country.iso_code }}"
              const parts = lang.split('-');
              if (parts.length >= 2) {
                  return (parts[1] || '').toUpperCase().trim();
              }
          } catch (e) {}
          return '';
      }

      birthdayInput() {
          this.input.value = "birth:" + this.dateInput.value;
      }

      shouldApplyUsAgeGate() {
          const rootUrl = (window.SHOP_LOCALES?.current?.root_url || window.poShopifyLocalization?.locale?.rootUrl || '').toLowerCase().replace(/\/$/, '');
          const path = window.location.pathname.toLowerCase();
          return ['/en-us', '/es-us'].includes(rootUrl) || /^\/(en-us|es-us)(?:\/|$)/.test(path);
      }

      handleBirthdayChange(event) {
          this.birthdayInput();
          
          // If we've already retrieved the country, validate the age immediately
          if (this.userCountry) {
              this.validateAge();
          } else {
              // Otherwise, we wait for fetchUserCountry to complete before validating
              console.log('Waiting for country detection before validating age...');
          }
      }

      validateAge() {
          if (!this.dateInput.value) {
    // Nessuna data: campo è facoltativo, reset eventuali errori
    if (this.birthdayErrorElement) {
        this.birthdayErrorElement.textContent = '';
        this.birthdayErrorElement.classList.add('tw-hidden');
        this.birthdayErrorElement.classList.remove('po-error-text');
        this.dateInput.classList.remove('tw-error-border');
        this.dateInput.closest('po-text-field').classList.remove('tw-po-textfield-error');

        const ageErrorMsg = this.querySelector('.age-error-message');
        if (ageErrorMsg) ageErrorMsg.remove();
    }

    // Riabilita il bottone se precedentemente disabilitato
    const submitButton = document.querySelector(this.dataset.submitButton);
    if (submitButton) {
        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('tw-opacity-50');
        submitButton.removeAttribute('title');
    }

    return true;
}


          const birthDate = new Date(this.dateInput.value);
          const today = new Date();
          
          let age = today.getFullYear() - birthDate.getFullYear();
          const monthDiff = today.getMonth() - birthDate.getMonth();
          
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
              age--;
          }

          // Check minimum age based on country
          // Only US users are blocked by age. All other markets can proceed without disclaimer.
          let isValid = true;
          let errorMessage = '';
          let minAge = 0;

          if (this.shouldApplyUsAgeGate()) {
              minAge = 18;
              if (age < minAge) {
                  isValid = false;
                  errorMessage = this.dataset.errorUs || `You must be at least ${minAge} years old to register in the United States.`;
              }
          }

          if (!isValid) {
              // Show error message
              if (this.birthdayErrorElement) {
                  this.birthdayErrorElement.textContent = errorMessage;
                  this.birthdayErrorElement.classList.remove('tw-hidden');
                  this.birthdayErrorElement.classList.add('po-error-text');
                  this.dateInput.classList.add('tw-error-border');
                  this.dateInput.closest('po-text-field').classList.add('tw-po-textfield-error');
                  
                  // Disable submit button
                  const submitButton = document.querySelector(this.dataset.submitButton);
                  if (submitButton) {
                      submitButton.setAttribute('disabled', 'disabled');
                      submitButton.classList.add('tw-opacity-50');
                      submitButton.title = errorMessage; // Add tooltip to explain why it's disabled
                  }
                  
                  // Add specific message under the date field
                  const yourLabel = this.dataset.errorAgeYour || 'Your age:';
                  const minLabel = this.dataset.errorAgeMin || 'Minimum required age:';
                  let ageErrorMsg = this.querySelector('.age-error-message');
                  if (!ageErrorMsg) {
                      ageErrorMsg = document.createElement('div');
                      ageErrorMsg.classList.add('age-error-message', 'tw-text-red-500', 'tw-text-xs', 'tw-mt-1');
                      this.appendChild(ageErrorMsg);
                  }
                  ageErrorMsg.textContent = `${yourLabel} ${age} years. ${minLabel} ${minAge} years.`;
              }
          } else {
              // Hide error message
              if (this.birthdayErrorElement) {
                  this.birthdayErrorElement.textContent = '';
                  this.birthdayErrorElement.classList.add('tw-hidden');
                  this.birthdayErrorElement.classList.remove('po-error-text');
                  this.dateInput.classList.remove('tw-error-border');
                  this.dateInput.closest('po-text-field').classList.remove('tw-po-textfield-error');
                  
                  // Re-enable submit button
                  const submitButton = document.querySelector(this.dataset.submitButton);
                  if (submitButton) {
                      submitButton.removeAttribute('disabled');
                      submitButton.classList.remove('tw-opacity-50');
                      submitButton.removeAttribute('title');
                  }
                  
                  // Remove specific age message
                  const ageErrorMsg = this.querySelector('.age-error-message');
                  if (ageErrorMsg) {
                      ageErrorMsg.remove();
                  }
              }
          }

          return isValid;
      }

      // Get the user's country using Shopify's locale information
      async fetchUserCountry() {
          try {
              const marketRegion = this.getMarketRegion();
              const countryFromLiquid = (this.dataset.country || '').toUpperCase().trim();
              const countryFromLang = this.getCountryFromHtmlLang();
              this.setUserCountry(countryFromLiquid || countryFromLang || 'DEFAULT');
          } catch (error) {
              this.setUserCountry('DEFAULT');
          }
      }

      // Handles setting the country and updating UI and validation
      setUserCountry(countryCode) {
        this.userCountry = countryCode || 'DEFAULT';

        // Show the age disclaimer only where the age block applies.
        const ageAdviseEl = document.getElementById('age-advise-disclaimer');
        if (ageAdviseEl) {
            ageAdviseEl.style.display = this.shouldApplyUsAgeGate() ? '' : 'none';
        }

        // Store the country in a hidden field for future use
        const existingCountryInput = this.querySelector('input[name="customer[country]"]');
        if (existingCountryInput) {
            existingCountryInput.value = this.userCountry;
        } else {
            const countryInput = document.createElement('input');
            countryInput.type = 'hidden';
            countryInput.name = 'customer[country]';
            countryInput.value = this.userCountry;
            this.appendChild(countryInput);
        }

        // Se la data è già stata selezionata, rilancia la validazione
        if (this.dateInput.value) {
            this.validateAge();
        }
    }

  }
  customElements.define("po-birthday-input", PoBirthdayInput);
}